import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.entries";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.pad-start";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _slicedToArray from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Editor from "@/components/Editor";
export default {
  components: {
    Editor: Editor
  },
  props: {
    GamesServersList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var validatePass = function validatePass(rule, value, callback) {
      var reg = /^(0\.\d+|[1](\.00)?)$/;

      if (value == '' || !reg.test(value)) {
        callback(new Error('请输入0-1之间的数字且保留一位小数'));
      } else {
        callback();
      }
    };

    var validateWelfare = function validateWelfare(rule, value, callback) {
      var reg = /^(100|[1-9]?\d)$/;

      if (!reg.test(value)) {
        callback(new Error('请输入0-100之间的数字'));
      } else {
        callback();
      }
    };

    return {
      form: {
        game_server_id: '',
        product_name: '',
        icon: '',
        currency: '',
        delay_time: '',
        price: '',
        state: '',
        cp_product: '',
        discount: '',
        params: [],
        show_name: '',
        welfare: 0,
        languageManage: [],
        restriction_type: '',
        restriction_num: '',
        rand_give_switch: 0,
        rand_give_gear: [{
          label: "",
          value: ""
        }]
      },
      paramsMark: {
        product_name: '',
        icon: '',
        content: '',
        language: ''
      },
      dateVal: [],
      dateVal1: this.getDefaultDayRange(),
      stateList: [{
        label: '启用',
        value: 2
      }, {
        label: '禁用',
        value: 1
      }, {
        label: '敬请期待',
        value: 3
      }],
      xiugaiList: [{
        label: '不修改',
        value: 1
      }, {
        label: '修改',
        value: 2
      }],
      dingshiList: [{
        label: '否',
        value: 1
      }, {
        label: '是',
        value: 2
      }],
      dingshi: 1,
      xiugai: 1,
      copyform: {},
      picfileList: [],
      dialogShow: false,
      limitationList: [{
        label: '每天',
        value: 1
      }, {
        label: '每周',
        value: 2
      }, {
        label: '每月',
        value: 3
      }, {
        label: '活动期间',
        value: 4
      }],
      rules: {
        show_name: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        game_server_id: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        product_name: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        icon: [{
          required: true,
          message: "请上传",
          trigger: "blur"
        }],
        currency: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        price: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        discount: [{
          required: true,
          validator: validatePass,
          trigger: "blur"
        }],
        content: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        state: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        delay_time: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        welfare: [{
          required: false,
          validator: validateWelfare,
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        value: [{
          required: true,
          message: "请输入内容",
          trigger: "blur"
        }] // iconPrev:[{ required: true, message: "请上传", trigger: "blur" }],

      },
      reqtype: 'Normal'
    };
  },
  created: function created() {
    this.copyform = _objectSpread({}, this.form);
    this.getlangList();
  },
  methods: {
    getDefaultDayRange: function getDefaultDayRange() {
      var now = new Date(); // 获取年、月、日（月份补0，日期补0，保证格式为yyyy-MM-dd）

      var year = now.getFullYear();
      var month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需+1

      var day = String(now.getDate()).padStart(2, '0'); // 拼接符合value-format的时间字符串

      var startTime = "".concat(year, "-").concat(month, "-").concat(day, " 00:00:00");
      var endTime = "".concat(year, "-").concat(month, "-").concat(day, " 23:59:59"); // 返回数组，适配datetimerange的绑定规则

      console.log("[startTime, endTime]", [startTime, endTime]);
      return [startTime, endTime];
    },
    handleRandGiveSwitchChange: function handleRandGiveSwitchChange(value) {
      this.form.rand_give_txt = '';
      this.form.rand_give_gear = [];
      this.dateVal1 = [];

      if (value === 1) {
        // 固定模式：设置默认时间范围
        this.dateVal1 = this.getDefaultDayRange();
      } else if (value === 2) {
        // 档位模式：至少保留一个空项
        this.form.rand_give_gear = [{
          label: "",
          value: ""
        }];
      }
    },
    init: function init(datas) {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var type, data, lang, list, giveResult;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                type = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : 'Normal';
                _this.dialogShow = true;
                _this.reqtype = type;
                _this.xiugai = 1;
                _this.dingshi = 1;

                if (datas) {
                  data = JSON.parse(JSON.stringify(datas));
                  lang = data.language ? data.language.split(',') : [];
                  list = [];

                  if (_this.reqtype == 'Normal') {
                    lang.forEach(function (i) {
                      list.push(data.params.findIndex(function (j) {
                        return j.language == i;
                      }) > -1 ? _objectSpread(_objectSpread({}, data.params.find(function (j) {
                        return j.language == i;
                      })), {}, {
                        languageName: _this.languageList.find(function (j) {
                          return j.sign == i;
                        }).name
                      }) : _objectSpread(_objectSpread({}, _this.paramsMark), {}, {
                        language: i,
                        languageName: _this.languageList.find(function (j) {
                          return j.sign == i;
                        }).name
                      }));
                    });
                    list.map(function (i) {
                      i.picfileList = i.icon ? [i.icon] : '';
                    });
                    data.params = list;
                  }

                  if (_this.reqtype == 'vip') {
                    // data.params.forEach(item => {
                    //   item.list.forEach(a => {
                    //     a.picfileList = a.icon ? [a.icon] : ''
                    //     a.prepicfileList = a.iconPrev ? [a.iconPrev] : ''
                    //   })
                    // })
                    data.languageManage = data.params;
                  }

                  if (data.rand_give_start_time && data.rand_give_end_time) {
                    data.dateVal1 = [data.rand_give_start_time, data.rand_give_end_time];
                    _this.dateVal1 = [data.rand_give_start_time, data.rand_give_end_time];
                  } else {
                    _this.dateVal1 = [];
                    data.dateVal1 = [];
                  }

                  data.discount = data.discount ? Number(data.discount).toFixed(2) : 1;
                  _this.form = _objectSpread({}, data);

                  if (_this.form.rand_give_switch == 2) {
                    giveResult = Object.entries(JSON.parse(_this.form.rand_give_gear)).map(function (_ref) {
                      var _ref2 = _slicedToArray(_ref, 2),
                          key = _ref2[0],
                          val = _ref2[1];

                      return {
                        label: key,
                        value: val
                      };
                    });
                    _this.form.rand_give_gear = giveResult;
                  } else {
                    _this.form.rand_give_gear = [{
                      label: "",
                      value: ""
                    }];
                  }

                  console.log("this.form==", _this.form);
                } else {
                  _this.dateVal1 = _this.getDefaultDayRange();
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getlangList: function getlangList() {
      var _this2 = this;

      this.$api.languageInfoData().then(function (res) {
        if (res.code == 0) {
          _this2.languageList = res.data;
        }
      });
    },
    imgChange: function imgChange(e, item, index) {
      this.form.params[index].picfileList = e;
      this.form.params[index].icon = e[0] && e[0].response ? e[0].response.data : '';
    },
    imgChange1: function imgChange1(e, index, ind) {
      this.form.languageManage[index].list[ind].picfileList = e;
      this.form.languageManage[index].list[ind].icon = e[0] && e[0].response ? e[0].response.data : '';
    },
    imgChangePre: function imgChangePre(e, index, ind) {
      this.form.languageManage[index].list[ind].prepicfileList = e;
      this.form.languageManage[index].list[ind].iconPrev = e[0] && e[0].response ? e[0].response.data : '';
    },
    addGiveContent: function addGiveContent() {
      this.form.rand_give_gear.push({
        label: "",
        value: ""
      });
    },
    removeGiveContent: function removeGiveContent(item) {
      if (this.form.rand_give_gear.length <= 1) {
        this.$message.warning('至少需要保留一个随机赠送配置字段');
        return;
      }

      var index = this.form.rand_give_gear.indexOf(item);

      if (index !== -1) {
        this.form.rand_give_gear.splice(index, 1);
      }
    },
    clearData: function clearData() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.form = _objectSpread(_objectSpread({}, this.copyform), {}, {
        id: type ? this.form.id : ""
      });
      this.xiugai = 1;
      this.dingshi = 1;
      this.picfileList = [];
      this.form.languageManage = [];
      this.dateVal1 = [];
      this.dateVal = [];
      this.$refs.ruleForm.resetFields();
    },
    severChange: function severChange() {
      var _this3 = this;

      var data = this.GamesServersList.find(function (i) {
        return i.id == _this3.form.game_server_id;
      });
      var lang = data.language ? data.language.split(',') : [];
      var list = [];
      lang.forEach(function (i) {
        list.push(_objectSpread(_objectSpread({}, _this3.paramsMark), {}, {
          language: i,
          languageName: _this3.languageList.find(function (j) {
            return j.sign == i;
          }).name,
          picfileList: ''
        }));
      });
      this.form.params = list;
      this.$nextTick(function () {
        var dialogs_body = document.getElementsByClassName("dialogs_body");
        dialogs_body.forEach(function (item) {
          item.scrollTop = 0;
        });
      });
    },
    addLanContent: function addLanContent() {
      this.form.languageManage.push({
        language: "",
        list: []
      });
    },
    removeLanContent: function removeLanContent(item) {
      var index = this.form.languageManage.indexOf(item);

      if (index !== -1) {
        this.form.languageManage.splice(index, 1);
      }
    },
    addContent: function addContent(item) {
      item.list.push({
        product_name: "",
        content: "",
        icon: "",
        iconPrev: "",
        picfileList: [],
        prepicfileList: []
      });
    },
    removecontent: function removecontent(index, idx) {
      this.form.languageManage[index].list.splice(idx, 1);
    },
    submitData: function submitData() {
      var _this4 = this;

      console.log("this.levelList", this.form);
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this4.form));
          var giveResult = {};

          if (_this4.form.rand_give_switch == 2) {
            giveResult = _this4.form.rand_give_gear.reduce(function (acc, item) {
              acc[item.label] = item.value;
              return acc;
            }, {});
          }

          data.rand_give_gear = giveResult;
          console.log("this.levelList", _this4.form);

          if (_this4.reqtype == 'Normal') {
            data.params.map(function (i) {
              i.picfileList = i.picfileList.map(function (j) {
                return j.response ? j.response.data : j.url;
              });
            });
            data.params = JSON.stringify(data.params);

            if (_this4.dateVal.length) {
              data.restriction_start_time = _this4.dateVal[0];
              data.restriction_end_time = _this4.dateVal[1];
            }

            if (_this4.dateVal1 && _this4.dateVal1.length) {
              data.rand_give_start_time = _this4.dateVal1[0];
              data.rand_give_end_time = _this4.dateVal1[1];
            } else {
              data.rand_give_start_time = '';
              data.rand_give_end_time = '';
            }
          } else {
            data.languageManage.forEach(function (item) {
              item.list.forEach(function (a) {
                a.picfileList = a.picfileList.map(function (b) {
                  return b.response ? b.response.data : a.icon;
                });
                a.prepicfileList = a.prepicfileList.map(function (b) {
                  return b.response ? b.response.data : a.iconPrev;
                });
              });
            });
            data.params = JSON.stringify(data.languageManage);
          }

          delete data.languageManage;
          var reqFn = '';

          if (_this4.reqtype == 'Normal') {
            reqFn = data.id ? 'paymentProductsUpdate' : 'paymentProductsAdd';
          } else if (_this4.reqtype == 'vip') {
            reqFn = data.id ? 'vipPaymentProductsUpdate' : 'vipPaymentProductsAdd';
          }

          data.delay_time = data.delay_time ? data.delay_time / 1000 : '';
          data.welfare = Number(data.welfare);

          _this4.$api[reqFn](data).then(function (res) {
            if (res.code == 0) {
              _this4.$message({
                message: '操作成功',
                type: 'success'
              });

              _this4.dialogShow = false;

              _this4.$emit('change');
            } else {
              _this4.$message.error(res.msg);
            }
          });
        }
      });
    }
  }
};